/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { Suspense, type ReactNode } from "react";
import { Spinner } from "./Spinner";

/** A lazily loaded surface, with the same centered spinner while its chunk arrives. */
export function Deferred({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="grid place-items-center py-20">
          <Spinner size="lg" />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
